export interface StatusInfo {
  translationKey: string;
  color: string;
}

export const productAvailabilityStatusMap: Record<string, StatusInfo> = {
  "1": {
    translationKey: "orderDetail.itemStatus.confirmationPending",
    color: "#f0ad4e",
  },
  "2": {
    translationKey: "orderDetail.itemAvailability.notConfirmed",
    color: "#d9534f",
  },
  "3": {
    translationKey: "orderDetail.itemAvailability.confirmedInsufficiently",
    color: "#f7b924",
  },
  "4": {
    translationKey: "orderDetail.itemAvailability.confirmedSufficiently",
    color: "#5cb85c",
  },
};

export default productAvailabilityStatusMap;
